module.exports = __webpack_public_path__ + "img/check-off-hover.86ffe8a3.svg";